import React, {  useState } from "react";
import {blog} from "./blog.js"

const Record = () => {
    
    const [onn,setOnn]=useState("");
    const data=(Title,Body)=>{
            setOnn(<div style={{"padding":"0% 20% 0% 20%"}}>
            <h1>{Title}</h1>
            <hr></hr>
            <p>{Body}</p>
            </div>)
    }
    const recordList =()=> {
        return blog.map((record)=>(
                <tr>
                    <td className="text-light">{record.Title}</td>
                    <td className="text-light">{record.date}</td>
                    <td>
                        <button onClick={() => data(record.Title, record.Body)}>Read More</button>
                    </td>
                </tr>
        ));
    };
    
   
    
    
    const here =()=>{
        let o={onn}
        if(o.onn==="") {
            console.log("dsv")
            return (<table className="table table-striped" style={{ marginTop: 20 }}>
                <thead className="text-light">
                    <tr>
                    <th>Title</th>
                    <th>Date</th>
                    <th>Action</th>
                    </tr>
                </thead>
                <tbody >{recordList()}</tbody>
                </table>)
        }
        else {
            return (
                <div>
                    <button onClick={()=>{setOnn(""); }}>Go back</button>
                    {onn}
                    <br></br>
                    <br></br>
                </div>
            )
        }
    }

// This following section will display the table with the records of individuals.
    return (
            <div className="text-light bg-dark">
                <h3>Blogs that don't encourage:</h3>
                {here()}
                <div style={{"height":"425px"}}></div>
            </div>
        );
    }
export default Record
